import React, { useState, useEffect } from 'react';
import "./tables.css"
import PageContainer from '../../components/PageContainer';
import Footer from '../../components/Footer';
import { AIRDROP_USERS_JSON } from '../../hooks/utils';

const FinalTable = () => {
    const [data, setData] = useState([] as any);
    const [searchTerm, setSearchTerm] = useState(''); // State for search term

    useEffect(() => {
        // Extract airdrop data from the JSON object and convert it to an array
        const airdropData = AIRDROP_USERS_JSON.airdrop;
        const parsedData = Object.entries(airdropData).map(([owner, allocation]) => ({
            owner,
            sum: allocation,
        }));
        // Sort data in descending order based on the allocation sum
        const sortedData = parsedData.sort((a: any, b: any) => b.sum - a.sum);
        setData(sortedData);
    }, []);

    const totalSonusTokens = data.reduce((acc: number, row: any) => acc + (row.sum || 0), 0);

    // Calculate the total allocation sum
    const totalAllocationSum = data.reduce((acc: any, row: any) => acc + (row.sum || 0), 0);

    // Helper function to export data as CSV
    const exportToCSV = () => {
        const headers = ['Owner', 'Airdrop Sonus'];
        const rows = data.map((row: any) => {
            const allocation = row.sum || 0;
            const airdropPercentage = (allocation / totalAllocationSum) * 100;
            const airdropSonus = (airdropPercentage * totalSonusTokens) / 100;
            return [row.owner, Math.round(airdropSonus)];
        });

        const csvContent = [headers, ...rows]
            .map((row) => row.map((cell: any) => `"${cell}"`).join(','))
            .join('\n');

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'all.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    // Filter data based on search term
    const filteredData = data.filter((row: any) =>
        row.owner.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <PageContainer>
            <main className="h-full" style={{ minHeight: '100vh', justifyItems: "center", paddingTop: "3rem" }}>
                <div style={{ display: 'flex', width: "100%", flexDirection: 'column', padding: "2rem" }}>
                    <h2 style={{ textAlign: "left", marginBottom: "1rem", fontSize: "1.5rem" }}>
                        {/* Total veSONUS = {totalSonusTokens} |  */}
                        Sonus Points + ve33 Projects + SwapBased + Community
                        {/* ve33 Projects + SwapBased + Sonus Points + Community */}
                    </h2>

                    {/* Search Bar */}
                    <div className='searchInput'>
                        <input
                            type="text"
                            placeholder="Search wallets..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            style={{ marginBottom: '20px', fontSize: '16px', width: '100%' }}
                        />
                    </div>

                    <div className="table-wrapper">
                        <table border={1}>
                            <thead>
                                <tr>
                                    <th>User</th>
                                    <th>Airdrop %</th>
                                    <th>Airdrop Sonus</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredData.map((row: any, index: any) => (
                                    <tr key={index}>
                                        <td>{row.owner}</td>
                                        <td>
                                            {((row.sum / totalAllocationSum) * 100).toFixed(5)}%
                                        </td>
                                        <td>
                                            {((row.sum / totalAllocationSum) * totalSonusTokens).toLocaleString("en-US")}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <button onClick={exportToCSV} style={{ marginTop: "20px" }} className='sonus-button'>
                        Export to CSV
                    </button>
                </div>
            </main>

            <Footer />
        </PageContainer>
    );
};

export default FinalTable;
